import { message, Space } from "antd";
import axios from "axios";
import PropTypes from "prop-types";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router";
import ActionBar from "../../../components/action-bar";
import ActionButton from "../../../components/action-button";
import MiniTable from "../../../components/mini-table";
import { Alerta } from "../../../constants";
import useDispatchWithResult from "../../../hooks/useDispatchWithResult";
import useLoading from "../../../hooks/useLoading";
import {
  fetchDocumentos,
  fetchLicencas,
  fetchUnidades,
  fetchVerificarLimite,
  isEditableSelector,
  unidadesAlertaNivelSelector,
  unidadesAlertasSelector,
  unidadesSearchSelector,
  unidadesSelector,
} from "../../../store/empresa";
import unwrapAxiosPromise from "../../../util/unwrapAxiosPromise";
import { openPopup } from "../../../util/window";
import Alertas from "../_Alertas";
import styles from "../_styles.less";
import EmpresaUnidadesTable from "./_table";
import useModulo from "../../../hooks/useModulo";

export default function EmpresaUnidadesDetailPage() {
  const miniTableRef = useRef();
  const { t } = useTranslation();
  const dispatch = useDispatchWithResult();
  const nivel = useSelector(unidadesAlertaNivelSelector);
  const isEditable = useSelector(isEditableSelector);
  const unidades = useSelector(unidadesSelector);
  const search = useSelector(unidadesSearchSelector);
  const alertas = useSelector(unidadesAlertasSelector);
  const loading = useLoading(fetchUnidades.typePrefix);
  const history = useHistory();
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const { moduloBasePath } = useModulo();
  const [loadingRemove, setLoadingRemove] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  const isNA =
    nivel === Alerta.Nivel.NA.id || nivel === Alerta.Nivel.inativo.id;

  const handleSearch = (search) => {
    dispatch(fetchUnidades({ empresaId, search }));
  };

  const handleCreate = () => {

  unwrapAxiosPromise(dispatch(fetchVerificarLimite()))
    .then(() => {
       history.replace(`${moduloBasePath}/empresas/${empresaId}/unidades/create`);
    })
    
};

  const handleRemove = () => {
    setLoadingRemove(true);
    unwrapAxiosPromise(
      axios.delete(`/empresas/${empresaId}/unidades`, {
        params: { ids: selectedIds },
      })
    )
      .then(() => {
        message.success(t("Registro(s) removido(s) com sucesso"));
        setSelectedIds([]);
        dispatch(fetchUnidades({ empresaId }));
        dispatch(fetchLicencas({ empresaId }));
        dispatch(fetchDocumentos({ empresaId }));
      })
      .finally(() => setLoadingRemove(false));
  };

  const handleDetail = (unidade) => {
    history.replace(
      `${moduloBasePath}/empresas/${empresaId}/unidades/${unidade.id}`
    );
  };

  const handleLogs = () => {
    openPopup(
      `/logs?categoria=/empresas/${empresaId}/unidades/`,
      `logs_/empresas/${empresaId}/unidades/`
    );
  };

  const actions = [];
  if (isEditable) {
    actions.push(
      <ActionButton.Create disabled={isNA} onClick={handleCreate} />
    );
    actions.push(
      <ActionButton.Remove
        disabled={selectedIds.length === 0 || isNA}
        onClick={handleRemove}
        loading={loadingRemove}
      />
    );
  }
  actions.push(<ActionButton.Logs noTitle onClick={handleLogs} />);
  actions.push(
    <MiniTable.DownloadButton
      disabled={loading || unidades.length === 0}
      miniTableRef={miniTableRef}
    />
  );
  const title = () => (
    <ActionBar search={search} onSearch={handleSearch}>
      {actions}
    </ActionBar>
  );
  return (
    <Space direction="vertical" className={styles["space-2"]}>
      <EmpresaUnidadesTable
        dataSource={unidades}
        loading={loading}
        miniTableRef={miniTableRef}
        onClick={handleDetail}
        onSelectedIdsChange={setSelectedIds}
        selectedIds={selectedIds}
        title={title}
      />
      <Alertas alertas={alertas} />
    </Space>
  );
}

EmpresaUnidadesDetailPage.propTypes = {
  unidades: PropTypes.array,
  onCreate: PropTypes.func,
  onRemove: PropTypes.func,
};
